import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FormBaseComponent } from '@platform/components/forms/form-base/form-base.component';
import { provideParentFormGroup } from '@platform/components/forms/forms.utils';

@Component({
  selector: 'app-form-toggle-user-status',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatInputModule, MatButtonModule, MatButtonToggleModule],
  templateUrl: './form-toggle-user-status.component.html',
  styleUrls: ['./form-toggle-user-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormToggleUserStatusComponent extends FormBaseComponent {}
